// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3LG36","bold":"_3jRea","para":"_1SUHp"};